import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getDesignReadyGames, getPlannedGames, gamesManifest, getLevelsForGame } from '../../data/loadData';
import { useProfileStore } from '../../store/profile';
import { levelsForAge } from '../../store/ageSettings';
import type { GameId } from '../../data/schemas';
import { VehicleCard } from './VehicleCard';
import { useProgressStore } from '../../store/progress';

export const GameSelectScreen: React.FC = () => {
  const navigate = useNavigate();
  const muted = useProgressStore((s) => s.muted);
  const setMuted = useProgressStore((s) => s.setMuted);
  const ageBand = useProfileStore((s) => s.profile?.ageBand ?? null);
  const ready = getDesignReadyGames();
  const planned = getPlannedGames();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#8ecae6] via-[#A8D8EA] to-[#669bbc] px-4 py-8">
      <div className="mx-auto max-w-5xl">
        <header className="mb-10 text-center">
          <h1 className="font-display text-5xl md:text-6xl font-bold text-white drop-shadow-lg">
            Kjør min …
          </h1>
          <p className="mt-3 font-body text-white/90 text-lg max-w-xl mx-auto">
            Velg en bil. Enkle, rolige spill for de minste.
          </p>
        </header>

        <div className="mb-6 flex flex-wrap gap-3 justify-center">
          <Link
            to="/klistremerker"
            className="inline-flex min-h-[96px] items-center rounded-2xl bg-white/90 px-6 font-display text-xl font-bold text-[#6441A5] shadow"
          >
            Klistremerkebok
          </Link>
          <Link
            to="/foreldre"
            data-name="parent-settings-link"
            className="inline-flex min-h-[96px] items-center rounded-2xl bg-white/70 px-6 font-display text-xl font-bold text-gray-700 shadow"
          >
            For voksne
          </Link>
          <button
            type="button"
            onClick={() => setMuted(!muted)}
            className="inline-flex min-h-[96px] min-w-[96px] items-center justify-center rounded-2xl bg-white/90 px-6 font-display text-xl font-bold text-gray-700 shadow"
            data-name="mute-toggle"
          >
            {muted ? 'Lyd av' : 'Lyd på'}
          </button>
        </div>

        <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {ready.map((game) => (
            <VehicleCard
              key={game.id}
              title={game.title}
              vehicle={game.vehicle}
              status={game.status}
              levelCount={levelsForAge(getLevelsForGame(game.id as GameId), ageBand).length}
              onClick={() => navigate(`/spill/${game.id}`)}
            />
          ))}
        </section>

        {planned.length > 0 ? (
          <section>
            <h2 className="font-display text-2xl font-bold text-white/80 mb-4 text-center">
              Flere kjøretøy snart
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {planned.map((game) => (
                <VehicleCard
                  key={game.id}
                  title={game.title}
                  vehicle={game.vehicle}
                  status={game.status}
                  dimmed
                />
              ))}
            </div>
          </section>
        ) : null}

        <p className="mt-10 text-center text-white/60 text-sm font-body">
          {gamesManifest.locale} · v{gamesManifest.version}
        </p>
      </div>
    </div>
  );
};

export default GameSelectScreen;
